"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCvv(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 11"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 9,
    x: 0.5,
    y: 0.5,
    stroke: "#C2C5CC",
    rx: 1,
    transform: "translate(3)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#4D4D4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.178 7.503c-1.104.08-2.426.12-3.964.12-11.4 0-10.28-2.494-7.173-3.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.469 4.907l2.228 2.686-2.459 2.527"
  }))));
}

var MemoSvgCvv = /*#__PURE__*/React.memo(SvgCvv);
var _default = MemoSvgCvv;
exports["default"] = _default;